// CRM 2.0 booking facts for the portal (M2-F9): Shortlisted / waiting for the Relationship
// Manager / the CRM's name and phone. Backend: routes/crm2PortalBooking.js. CRM 2.0 only.
import axios from "axios";
import { portalHeaders } from "./ServerOtp";

const apiUrl = `${process.env.REACT_APP_PAYMENT_LINK_URL}crm2/portal/booking`;

const unwrap = (promise) =>
	promise
		.then((res) => res.data?.data)
		.catch((err) => {
			throw new Error(err?.response?.data?.error || "Something went wrong. Please try again.");
		});

export const getCrm2Booking = (apId) => unwrap(axios.get(`${apiUrl}/by-booking/${apId}`));

export const getCrm2LeadBookings = (leadId) => unwrap(axios.get(`${apiUrl}/by-lead/${leadId}`));

// M3-F2 · logged-in customer (sends the portal session token)
// → the full CRM 2.0 card: stage, dates, money, step tracker, Application for Booking, KYC, review draft …
export const getCrm2Card = (apId) => unwrap(axios.get(`${apiUrl}/${apId}/card`, { headers: portalHeaders() }));

// → every CRM 2.0 card of the logged-in customer ("Your units (n)")
export const getCrm2Cards = () => unwrap(axios.get(`${apiUrl}/cards`, { headers: portalHeaders() }));
